<div class="display-container" tabindex="0">
  @if (line1() || line2()) {
  <div class="address-lines">
    <span class="display-text line-1">{{ line1() }}</span>
    <span class="display-text line-2">{{ line2() }}</span>
  </div>
  } @else {
  <span class="placeholder-text">{{ placeholder() }}</span>
  }
  <lucide-icon name="edit" [size]="16" class="edit-icon"></lucide-icon>
</div>
